import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Select from 'react-select';
import './CustomizeSelect.scss';
import { useIntl } from 'react-intl';
import { find } from 'lodash';

function CustomizeSelect({ option, value, onChange, isSearchable }) {
  const intl = useIntl();
  const [selectedOption, setSelectedOption] = React.useState(value);

  useEffect(() => {
    if (!option || !value) return;
    const valueOption = find(option, ['value', value]);

    setSelectedOption(valueOption);
  }, [value]);

  const handleSelectChange = (e) => {
    setSelectedOption(e);
    onChange(e.value);
  };

  return (
    <Select
      classNamePrefix="react-select"
      options={option}
      value={selectedOption}
      onChange={handleSelectChange}
      isSearchable={isSearchable}
      placeholder={intl.formatMessage({ id: 'member.profile.gender.DEFAULT' })}
    />
  );
}

CustomizeSelect.defaultProps = {
  option: [],
  value: null,
  onChange: () => {},
  isSearchable: false,
};

CustomizeSelect.propTypes = {
  option: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  isSearchable: PropTypes.bool,
};

export default CustomizeSelect;
